import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  value: '+800',
  label: 'Vendedores que ya usan el sistema'
}, {
  value: '10 min',
  label: 'Para calcular la rentabilidad de 20 productos'
}, {
  value: '53%',
  label: 'De ahorro vs comprar cada producto por separado'
}, {
  value: '90',
  label: 'Días del plan de escalado'
}];
const outcomes = [{
  emoji: '📊',
  text: 'Sabé exactamente cuánto ganás por cada producto'
}, {
  emoji: '💲',
  text: 'Calculá el precio mínimo antes de publicar'
}, {
  emoji: '🔴',
  text: 'Nunca más sin stock en el momento clave'
}, {
  emoji: '💱',
  text: 'Actualizá márgenes con el dólar en segundos'
}, {
  emoji: '📈',
  text: 'Un plan semana a semana para crecer con sistema'
}, {
  emoji: '🔍',
  text: 'Evaluá nuevos productos antes de invertir'
}];
export function SocialProofSection() {
  return <section className="bg-navy-mid py-16 md:py-24" data-id="element-237">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-238">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-239">
          <h2 className="font-display font-extrabold text-3xl md:text-4xl lg:text-5xl text-white" data-id="element-240">
            Resultados concretos, no promesas vacías
          </h2>
        </motion.div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-14" data-id="element-241">
          {stats.map((stat, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.08
        }} className="bg-white/5 border border-white/5 rounded-xl p-5 text-center" data-id="element-242">
              <div className="text-gold font-display font-bold text-2xl md:text-3xl mb-1" data-id="element-243">
                {stat.value}
              </div>
              <div className="text-white/50 text-sm" data-id="element-244">{stat.label}</div>
            </motion.div>)}
        </div>

        {/* Outcome Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-245">
          {outcomes.map((outcome, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.08
        }} className="bg-navy-dark/60 border border-white/5 rounded-2xl p-6 flex items-start gap-4" data-id="element-246">
              <span className="text-3xl shrink-0" data-id="element-247">{outcome.emoji}</span>
              <p className="text-white font-semibold leading-relaxed" data-id="element-248">
                {outcome.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}